module.exports = __webpack_public_path__ + "static/media/AoA_CloseUp_6.61ad0771.jpg";